"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTabs = void 0;
var colors_1 = require("../../generated/colors");
var createMuiTabs = function (theme) {
    var _a;
    return ({
        defaultProps: {
            centered: true,
            indicatorColor: "primary",
        },
        styleOverrides: {
            root: {
                "& .MuiTabs-flexContainer": (_a = {},
                    _a[theme.breakpoints.down("md")] = {
                        display: "flex",
                        justifyContent: "space-around",
                    },
                    _a.borderBottom = "4px solid " + colors_1.colors.Mint25,
                    _a),
                "& .MuiTabs-indicator": {
                    height: "4px",
                },
            },
        },
    });
};
exports.createMuiTabs = createMuiTabs;
//# sourceMappingURL=tabs.js.map